<template>
  <div>
    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
    <h4 class="title is-4">{{createOrUpdate}}</h4>
    <hr />
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label is-small">Employee</label>
          <div class="control">
            <span v-show="leave.leaveId != 0">{{employeeName}}</span>
            <b-autocomplete v-show="leave.leaveId == 0" v-model="employeeName" size="is-small" :data="employees" placeholder="Search employees" @select="option => selectedEmployee = option" @input="searchEmployees" :loading="isFetchingEmployees" v-validate="'required'" name="Employee name">
              <template slot="empty">
                <span v-if="isFetchingEmployees">
                  Please wait...
                </span>
                <span v-if="employees.length === 0">
                  No results found
                </span>
              </template>
            </b-autocomplete>
            <span style="font-size:12px" class="has-text-danger">{{ errors.first('Employee name') }}</span>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">Approved By</label>
          <div class="control">
            <input type="text" v-model="leave.approvedBy" class="input is-small" />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">Status</label>
          <div class="control">
            <div class="select is-small">
              <select v-model="leave.status">
                <option value="0">Pending</option>
                <option value="1">Approved</option>
                <option value="2">Disapproved</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="column"></div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label is-small">Payroll From</label>
          <div class="control">
            <input type="date" v-model="leave.payrollFrom" class="input is-small" />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">Payroll To</label>
          <div class="control">
            <input type="date" v-model="leave.payrollTo" class="input is-small" />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">&nbsp;</label>
          <div class="control">
            <b-checkbox class="is-small" v-model="leave.isPaid" :disabled="isPaidDisabled">Is paid?
              <span v-if="employeeTotalLeave !== null">
                <i>{{employeeTotalLeave}} remaining leave(s)</i>
              </span>
            </b-checkbox>
          </div>
        </div>
      </div>
      <div class="column"></div>
    </div>
    <div style="clear:both"></div>
    <br />
    <h6 class="title is-6">Leave Detail</h6>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label is-small">Type of Leave</label>
          <div class="control">
            <div class="select is-small">
              <select @change="typeOfLeaveChange" v-model="leaveDetail.typeOfLeave">
                <option value="0">Leave Of Absence</option>
                <option value="1">Sick Leave</option>
                <option value="2">Vacation Leave</option>
                <option value="3">Maternatiy Leave</option>
                <option value="4">Half-day Leave</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="column"></div>
      <div class="column"></div>
      <div class="column"></div>
      <div class="column"></div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label is-small">Reason for leave</label>
          <div class="control">
            <textarea class="input is-small" v-model="leaveDetail.reasonForLeave" />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">Date from</label>
          <div class="control">
            <input type="date" class="input is-small" @change="dateFromChange" v-model="leaveDetail.dateFrom" />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">Date to</label>
          <div class="control">
            <input type="date" :disabled="isDateToDisabled" class="input is-small" v-model="leaveDetail.dateTo" />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">&nbsp;</label>
          <button class="button is-small is-info" @click="addToLeaveTable">Add</button>
        </div>
      </div>
    </div>
    <span style="font-size:12px" class="has-text-danger" v-show="isLeaveDetailEmpty">Leave detail is empty. Please add one or more leave detail.</span>
    <b-table :data="leaveDetails" :loading="isLoadingTable">
      <template slot-scope="item">
        <b-table-column class="table-column-content-is-small" label="Reason for leave">
          {{item.row.reasonForLeave}}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Date from">
          {{item.row.dateFrom}}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Date to">
          {{item.row.dateTo}}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Type of Leave">
          <span v-if="item.row.typeOfLeave == 0">Leave of Absence</span>
          <span v-if="item.row.typeOfLeave == 1">Sick Leave</span>
          <span v-if="item.row.typeOfLeave == 2">Vacation Leave</span>
          <span v-if="item.row.typeOfLeave == 3">Maternaty Leave</span>
          <span v-if="item.row.typeOfLeave == 4">Half-day Leave</span>
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Total Day">
          {{item.row.totalDay}}
        </b-table-column>
        <b-table-column>
          <button class="button is-small is-danger" @click="removeLeaveDetail(item.row.leaveDetailId ? item.row.leaveDetailId : item.row.tempId)">Remove</button>
        </b-table-column>
      </template>
    </b-table>
    <div class="level">
      <div class="level-left">
        &nbsp;
      </div>
      <div class="level-right">
        <button :class="buttonSave" @click="submitLeave">Save</button>
        &nbsp;
        <router-link :to="{name: 'List Of Leave'}" class="button is-small">Go back to list</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import debounce from 'lodash/debounce'
import axios from 'axios'
import moment from 'moment'
import AppToast from '../frontend/appToast'
import AppButton from '../frontend/appButton'

const appToast = new AppToast()
const appButton = new AppButton()

export default {
  created() {
    const leaveId = this.$route.params.leaveId
    if (leaveId) {
      this.createOrUpdate = '...'
      this.getLeaveById(leaveId)
    }
  },
  data() {
    return {
      createOrUpdate: 'Create',
      leave: {
        leaveId: 0,
        status: 0
      },
      isLoadingTable: false,
      leaveDetail: {
        reasonForLeave: '',
        dateFrom: '',
        dateTo: '',
        isPaid: false,
        tempId: '',
        typeOfLeave: 0
      },
      leaveDetails: [],
      // search employee
      employeeName: '',
      employees: [],
      selectedEmployee: 0,
      isFetchingEmployees: false,
      // form element
      isDateToDisabled: false,
      buttonSave: appButton.isLoadingSuccess(false),
      isLeaveDetailEmpty: false,
      isLoading: false,
      employeeTotalLeave: null,
      isPaidDisabled: false
    }
  },
  methods: {
    searchEmployees: debounce(function() {
      this.isFetchingEmployees = true
      axios
        .get(`api/employees/search-by-name/${this.employeeName}`)
        .then(response => {
          this.employees = response.data
        })
        .catch(error => {
          console.log(error)
        })
        .then(() => {
          this.isFetchingEmployees = false
        })
    }, 500),
    getEmployeeTotalLeaveByEmpId(id) {
      this.isLoading = true
      axios
        .get(`api/employees/remaining-leaves/${id}`)
        .then(response => {
          this.employeeTotalLeave = response.data
          if (this.employeeTotalLeave <= 0) {
            this.isPaidDisabled = true
          } else {
            this.isPaidDisabled = false
          }
        })
        .catch(error => {
          console.log(error)
          this.employeeTotalLeave = null
          this.isPaidDisabled = false
        })
        .then(() => {
          this.isLoading = false
        })
    },
    getEmployeeNameByEmployeeId(id) {
      axios
        .get(`api/employees/${id}`)
        .then(response => {
          this.employeeName = response.data.employeeName
          this.getEmployeeTotalLeaveByEmpId(id)
        })
        .catch(error => {
          console.log(error)
        })
    },
    getLeaveById(id) {
      this.isLoading = true
      axios
        .get(`api/leaves/${id}`)
        .then(response => {
          response.data.payrollFrom = moment(response.data.payrollFrom).format(
            'YYYY-MM-DD'
          )
          response.data.payrollTo = moment(response.data.payrollTo).format(
            'YYYY-MM-DD'
          )
          this.leave = response.data

          response.data.leaveDetails.forEach(leaveDetail => {
            leaveDetail.dateFrom = moment(leaveDetail.dateFrom).format(
              'YYYY-MM-DD'
            )
            leaveDetail.dateTo = moment(leaveDetail.dateTo).format('YYYY-MM-DD')
          })

          this.leaveDetails = response.data.leaveDetails

          this.getEmployeeNameByEmployeeId(response.data.employeeId)
        })
        .catch(error => {
          console.log(error)
          //this.$route.push('/leaves/')
        })
        .then(() => {
          this.createOrUpdate = 'Edit'
          this.isLoading = false
        })
    },
    addToLeaveTable() {
      var dateFrom = moment(this.leaveDetail.dateFrom)
      var dateTo = moment(this.leaveDetail.dateTo)

      var totalDay = 0

      if (dateFrom.valueOf() == dateTo.valueOf()) {
        totalDay = 1
      } else {
        totalDay = dateTo.diff(dateFrom, 'days') + 1
      }

      this.leaveDetails = [
        {
          leaveId: 0,
          reasonForLeave: this.leaveDetail.reasonForLeave,
          dateFrom: this.leaveDetail.dateFrom,
          dateTo: this.leaveDetail.dateTo,
          typeOfLeave: this.leaveDetail.typeOfLeave,
          totalDay: totalDay,
          tempId: `t${new Date().getTime()}` // t = temp
        },
        ...this.leaveDetails
      ]

      this.isLeaveDetailEmpty = false

      this.defaultLeaveDetail()
    },
    removeLeaveDetail(id) {
      this.isLoadingTable = true
      // check if id is temp or with t
      const idTypeOf = typeof id
      if (idTypeOf === 'string') {
        // check if id is string, if it is string, remove from the array, if not, remove from the database
        const hasT = id.charAt(0)
        if (hasT === 't') {
          _.remove(this.leaveDetails, { tempId: id }) // Create module
        }
      } else {
        axios
          .delete(`api/leaves/detail/${id}`)
          .then(response => {
            // id = leaveDetailId
            appToast.success(response.data)
          })
          .catch(error => {
            console.log(error)
          })
          .then(() => {
            this.default()
            this.getLeaveById(id)
          })
      }
      this.isLoadingTable = false
    },
    submitLeave() {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.leaveDetails.length != 0) {
            this.isLeaveDetailEmpty = false
            this.buttonSave = appButton.isLoadingSuccess(true)

            const payrollDateFrom = new Date(this.leave.payrollFrom)
            const payrollDateTo = new Date(this.leave.payrollTo)

            const leaveToSave = {
              leaveId: this.leave.leaveId,
              employeeId: this.leave.employeeId
                ? this.leave.employeeId
                : this.selectedEmployee.pkey,
              status: this.leave.status,
              approvedBy: this.leave.approvedBy,
              payrollFrom: isNaN(payrollDateFrom) ? null : payrollDateFrom,
              payrollTo: isNaN(payrollDateTo) ? null : payrollDateTo,
              isPaid: this.leave.isPaid,
              leaveDetails: this.leaveDetails
            }
            const leaveId = this.leave.leaveId
            if (leaveId == 0) {
              // Create
              axios
                .post('api/leaves', leaveToSave)
                .then(response => {
                  appToast.success(response.data)
                  this.$router.push({ name: 'List Of Leave' })
                })
                .catch(error => {
                  appToast.danger(error.response.data)
                  this.buttonSave = appButton.isLoadingSuccess(false)
                })
            } else {
              // Edit
              axios
                .put(`api/leaves/${leaveId}`, leaveToSave)
                .then(response => {
                  appToast.success(response.data)
                })
                .catch(error => {
                  appToast.danger(error.response.data)
                  this.buttonSave = appButton.isLoadingSuccess(false)
                })
                .then(() => {
                  this.default()
                  this.getLeaveById()
                })
            }
          } else {
            this.isLeaveDetailEmpty = true
          }
        }
      })
    },
    default() {
      this.$nextTick(() => {
        this.$validator.reset()
      })
      this.employeeTotalLeave = null
      this.buttonSave = appButton.isLoadingSuccess(false)
      this.isLeaveDetailEmpty = false
    },
    defaultLeaveDetail() {
      this.leaveDetail = {
        reasonForLeave: '',
        dateFrom: '',
        dateTo: '',
        isPaid: false,
        tempId: '',
        typeOfLeave: 0
      }

      this.isDateToDisabled = false
    },
    dateFromChange() {
      this.ifTypeOfLeaveIsHalfDay()
    },
    typeOfLeaveChange() {
      if (this.leaveDetail.typeOfLeave == 4) {
        this.isDateToDisabled = true
      } else {
        this.isDateToDisabled = false
      }
    },
    // form element
    ifTypeOfLeaveIsHalfDay() {
      this.isDateToDisabled
        ? (this.leaveDetail.dateTo = this.leaveDetail.dateFrom)
        : (this.leaveDetail.dateTo = null)
    }
  },
  watch: {
    isDateToDisabled() {
      this.ifTypeOfLeaveIsHalfDay()
    },
    selectedEmployee() {
      if (this.selectedEmployee) {
        this.getEmployeeTotalLeaveByEmpId(this.selectedEmployee.pkey)
      } else {
        this.employeeTotalLeave = null
      }
    }
  }
}
</script>
